import * as React from 'react';
import ArrowRotateLeftOutlined from './arrow-rotate-left-outlined';
import ArrowRotateLeftFilled from './arrow-rotate-left-filled';
import type { IconCombinedProps } from './types';
const ArrowRotateLeftCombined = React.forwardRef<SVGSVGElement, IconCombinedProps>((props, ref) => {
  const {
    isFocused,
    isHovered,
    isPressed,
    ...rest
  } = props;
  if (isFocused || isHovered || isPressed) {
    return <ArrowRotateLeftFilled ref={ref} {...rest} />;
  }
  return <ArrowRotateLeftOutlined ref={ref} {...rest} />;
});
export default ArrowRotateLeftCombined;